<script setup>
import { ref, onMounted, onUnmounted } from "vue";

defineProps(["src"]);

const height = ref("100vh");
const origin = "https://app.termly.io";

function message(event) {
	if (event.origin !== origin)
		return;

	let res;

	if ((res = event.data.match(/iframe:get_size:(\d+)/)))
		height.value = parseInt(res[1]) + 20 + "px";
	else if ((res = event.data.match(/scroll_to:(\d+)/)))
		scrollTo({ top: parseInt(res[1]) });
}

function load(e) {
	e.target.contentWindow.postMessage(`iframe:init_scrolling:${e.target.parentElement.offsetTop}`, origin);
	e.target.contentWindow.postMessage("iframe:get_size", origin);

	const iframe = e.target;

	onresize = () => iframe.contentWindow.postMessage("iframe:get_size", origin);
}

onMounted(() => addEventListener("message", message));
onUnmounted(() => removeEventListener("message", message));
</script>

<template>
	<UiIframe :src="src" :style="{ height }" @load="load"/>
</template>
